export default __webpack_public_path__ + "static/header.pan.uebersicht-830f4674baa524f402b0660676c02446.png";